import React from "react";

import GenericSelector from "./GenericSelector";

const BOOLEAN_OPTIONS = [
  { value: true, label: "Sí" },
  { value: false, label: "No" },
];

export default function BooleanSelector({ value = "", ...props }) {
  return (
    <GenericSelector {...props} value={value ?? ""} options={BOOLEAN_OPTIONS} />
  );
}
